module.exports = __webpack_public_path__ + "img/profitability6.8f92e292.png";